import { useState } from "react";
import { Menu, X } from "lucide-react";
import RiverLogo from "@/components/RiverLogo";
import { scrollToId, scrollToTop } from "@/lib/scroll";

const LINKS = [
    { id: "crisis", label: "The Issue" },
    { id: "history", label: "The River" },
    { id: "product", label: "The Guardian" },
    { id: "difference", label: "The Difference" },
    { id: "culture", label: "Culture" },
    { id: "financials", label: "Financials" },
    { id: "roadmap", label: "Expansion" },
];

export const scrollTo = scrollToId;

export default function Nav() {
    const [open, setOpen] = useState(false);

    return (
        <header className="fixed top-0 inset-x-0 z-40 backdrop-blur-xl bg-[#020D18]/70 border-b border-[#12283C]">
            <div className="max-w-7xl mx-auto px-6 lg:px-8 h-16 flex items-center justify-between">
                <button
                    data-testid="nav-logo"
                    onClick={scrollToTop}
                    className="flex items-center gap-2.5 group"
                >
                    <RiverLogo />
                    <span className="font-display font-semibold tracking-tight text-xl">
                        River<span className="text-sky-200">Guardian</span>
                    </span>
                </button>

                <nav className="hidden md:flex items-center gap-7" data-testid="nav-links">
                    {LINKS.map((link) => (
                        <button
                            key={link.id}
                            data-testid={`nav-link-${link.id}`}
                            onClick={() => scrollTo(link.id)}
                            className="nav-link text-base text-slate-300 hover:text-sky-200 transition-colors"
                        >
                            {link.label}
                        </button>
                    ))}
                    <button
                        data-testid="nav-cta-button"
                        onClick={() => scrollTo("contact")}
                        className="text-base font-semibold bg-sky-400 hover:bg-sky-300 text-[#020D18] px-5 py-2 rounded-full transition-[background-color,transform] duration-300 hover:scale-[1.05] active:scale-[0.96]"
                    >
                        Request Tender Brief
                    </button>
                </nav>

                <button
                    data-testid="nav-menu-toggle"
                    className="md:hidden text-slate-200 p-2"
                    onClick={() => setOpen(!open)}
                    aria-label="Toggle menu"
                >
                    {open ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
                </button>
            </div>

            {open && (
                <nav className="md:hidden border-t border-[#12283C] bg-[#020D18]/95 px-6 py-4 flex flex-col gap-4" data-testid="nav-mobile-menu">
                    {LINKS.map((link) => (
                        <button
                            key={link.id}
                            data-testid={`nav-mobile-link-${link.id}`}
                            onClick={() => {
                                scrollTo(link.id);
                                setOpen(false);
                            }}
                            className="text-left text-base text-slate-300 hover:text-sky-200 transition-colors"
                        >
                            {link.label}
                        </button>
                    ))}
                    <button
                        data-testid="nav-mobile-cta-button"
                        onClick={() => {
                            scrollTo("contact");
                            setOpen(false);
                        }}
                        className="text-base font-semibold bg-sky-400 text-[#020D18] px-5 py-2 rounded-full w-fit"
                    >
                        Request Tender Brief
                    </button>
                </nav>
            )}
        </header>
    );
}
